import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"
import { EducationStatusRequest, EducationStatusResponse } from "./types/education"
import { OccupationRequest, OccupationResponse, GetCitiesResponse, GetTownsResponse, GetTownsRequest, GetDistrictsResponse, GetDistrictsRequest, GetVarlikKaynagiResponse, GetIslemHacimleriResponse, GetIslemSayisiResponse } from "./types/job"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { Apply5Request, Apply5Response } from "./types/apply5"
import { GetCountryListRequest, GetCountryListResponse } from "./types/country"
import { Apply6Request, Apply6Response } from "./types/apply6"
import { GetBranchByNameRequest, GetBranchByNameResponse } from "./types/getBranchByName"
import { GetSectorListRequest, GetSectorListResponse } from "./types/getSectorList"
import { GetWorkPlaceNameByNameRequest, GetWorkPlaceNameByNameResponse } from "./types/getWorkPlaceNameByName"

const functionCode = "CRC0003"
const errorCounter = "3"
const lockHours = "24"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "CRC0003",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          dogumGun: body.dogumGun,
          dogumAy: body.dogumAy,
          dogumYil: body.dogumYil,
          cepTel: body.cepTel,
          captcha: body.captcha,
          kvkk: body.kvkk,
          cid: body.cid,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/Apply1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/ResendOtp1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          sid: body.sid,
          tc9g: body.tc9g,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/Apply2",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/Apply3",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getSecondNationalyCountryList: builder.mutation<GetCountryListResponse, GetCountryListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/SecondNationalityCountryList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getEducationStatuses: builder.mutation<EducationStatusResponse, EducationStatusRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/EducationalStatusList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getOccupations: builder.mutation<OccupationResponse, OccupationRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          meslekIsTuruKodu: body.meslekIsTuruKodu,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/WorkTypeList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4: builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          yerlesikUlke: body.yerlesikUlke,
          yurtdisiBaglantisi: body.yurtdisiBaglantisi,
          ogrenimDurumu: body.ogrenimDurumu,
          meslek: body.meslek,
          email: body.email,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/Apply4",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply5: builder.mutation<Apply5Response, Apply5Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          clsBrmKod: body.clsBrmKod,
          ciro: body.ciro,
          sektor: body.sektor,
          kurulusTarihi: body.kurulusTarihi,
          varlikKaynagi: body.varlikKaynagi,
          islemHacmi: body.islemHacmi,
          islemSayisi: body.islemSayisi,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/Apply5",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply6: builder.mutation<Apply6Response, Apply6Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          cardType: body.cardType,
          isyeriAdi: body.isyeriAdi,
          isAdresi: body.isAdresi,
          paymentWeek: body.paymentWeek,
          currency: body.currency,
          isDigitalEkstre: body.isDigitalEkstre,
          isTroy: body.isTroy,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/Apply6",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCities: builder.mutation<GetCitiesResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getTowns: builder.mutation<GetTownsResponse, GetTownsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/DistrictsList1",
          ilKodu: body.ilKodu,
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getDistricts: builder.mutation<GetDistrictsResponse, GetDistrictsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/DigitalProductLookupData/GetMahalleler1",
          ilId: body.ilId,
          ilceId: body.ilceId,
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getVarlikKaynagi: builder.mutation<GetVarlikKaynagiResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddVarlikKaynagiTicariList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getIslemHacimleri: builder.mutation<GetIslemHacimleriResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddIslemHacmiList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getIslemSayisi: builder.mutation<GetIslemSayisiResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddIslemSayisiTicariList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getBranchByName: builder.mutation<GetBranchByNameResponse, GetBranchByNameRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          subeAdi: body.subeAdi,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/BranchesList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getSectorList: builder.mutation<GetSectorListResponse, GetSectorListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          sektorAdi: body.sektorAdi,
          NextTransactionUrl: "Facebook/WebCommercialCreditCard/GetSectorList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkPlaceNameByName: builder.mutation<GetWorkPlaceNameByNameResponse, GetWorkPlaceNameByNameRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          name: body.name,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/WorkPlaceName1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
  })
})

export const { useGetTokenByTckn1Mutation, useGetConfigListMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation, useGetEducationStatusesMutation, useGetOccupationsMutation, useApply4Mutation, useApply5Mutation, useApply6Mutation, useGetSecondNationalyCountryListMutation, useGetCitiesMutation, useGetTownsMutation, useGetDistrictsMutation, useGetVarlikKaynagiMutation, useGetIslemHacimleriMutation, useGetIslemSayisiMutation, useGetBranchByNameMutation, useGetSectorListMutation, useGetWorkPlaceNameByNameMutation } = api

export default api
